// Utilitaires de formatage pour le français canadien

/**
 * Formate une date au format français (jj-mm-aaaa)
 * @param {string|Date} dateInput - Date à formater
 * @returns {string} Date formatée
 */
export const formatDateFR = (dateInput) => {
  if (!dateInput) return '';
  
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return '';
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  
  return `${day}-${month}-${year}`;
};

/**
 * Formate un prix au format français canadien (montant $)
 * @param {number|string} amount - Montant à formater
 * @param {boolean} showDecimals - Afficher les décimales (défaut: true)
 * @returns {string} Prix formaté
 */
export const formatPriceFR = (amount, showDecimals = true) => {
  const num = parseFloat(amount);
  if (isNaN(num)) return '0 $';
  
  if (showDecimals) {
    return `${num.toFixed(2).replace('.', ',')} $`;
  }
  return `${Math.round(num)} $`;
};

/**
 * Formate un prix simplifié (sans décimales si entier)
 * @param {number|string} amount - Montant à formater
 * @returns {string} Prix formaté
 */
export const formatPriceSimple = (amount) => {
  const num = parseFloat(amount);
  if (isNaN(num)) return '0 $';
  
  // Si le nombre est entier, pas de décimales
  if (num % 1 === 0) {
    return `${num} $`;
  }
  return `${num.toFixed(2).replace('.', ',')} $`;
};

/**
 * Traduit les statuts de transaction en français
 * @param {string} status - Statut en anglais
 * @returns {string} Statut traduit
 */
export const translateStatus = (status) => {
  const statusMap = {
    'created': 'Créée',
    'pending': 'En attente',
    'pending_confirmation': 'En attente de confirmation',
    'pending_tickets': 'Billets en attente',
    'confirmed': 'Confirmée',
    'tickets_uploaded': 'Billets téléversés',
    'ocr_verified': 'Vérifié par OCR',
    'admin_verified': 'Vérifié par admin',
    'tickets_verified': 'Billets vérifiés',
    'payment_pending': 'Paiement en attente',
    'payment_received': 'Paiement reçu',
    'payment_completed': 'Paiement complété',
    'funds_released': 'Fonds envoyés',
    'tickets_transferred': 'Billets transférés',
    'completed': 'Complétée',
    'disputed': 'Contestée',
    'cancelled': 'Annulée',
    'expired': 'Expirée',
    'refunded': 'Remboursée'
  };
  
  return statusMap[status] || status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};
